// extracted by mini-css-extract-plugin
export var active = "Header-module--active--27cf8";
export var brand = "Header-module--brand--2db1f";
export var brandLogo = "Header-module--brandLogo--bb12f";
export var brandName = "Header-module--brandName--e73cb";
export var header = "Header-module--header--6728e";
export var iconClose = "Header-module--iconClose--56c3e";
export var iconMenu = "Header-module--iconMenu--2312e";
export var index = "Header-module--index--2b33b";
export var navArrow = "Header-module--navArrow--d3d3c";
export var opened = "Header-module--opened--cf1ed";
export var toggle = "Header-module--toggle--855dc";